<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Admins</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Search" @keyup="searchit" v-model="search" aria-label="Search">
                    <button class="btn btn-success" @click="newAdmin()">Add New</button>

                    <vue-excel-xlsx
                        :data="admin_mastersExcel"
                        :columns="columns"
                        :filename="'AdminData'"
                        :sheetname="'sheetname'"
                        class="btn btn-success"
                        >
                        Excel
                    </vue-excel-xlsx>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>NO</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Email</th>
                            <th>Modify</th>
                        </tr>
                        <tr v-for="(admin_master,i) in admin_masters.data" :key="admin_master.id">
                            <td>{{ i+1 }}</td>
                            <td> {{ admin_master.name}} </td>
                            <td> {{ admin_master.User_Status}} </td>
                            <td>{{ admin_master.email }}</td>
                            <td v-if="userglobaldata.User_Status == 'SuperAdmin'">
                                <a v-if="admin_master.User_Status != 'SuperAdmin'" href="#" @click="editAdmin(admin_master)"><i class="fas fa-edit"></i></a>/
                                <a v-if="admin_master.User_Status != 'SuperAdmin'" href="#" @click="deleteAdmin(admin_master.id)"><i class="fas fa-trash-alt red"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="admin_masters" @pagination-change-page="loadAndSearchAdmin" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchAdmin(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
                <!-- Modal -->
            <div class="modal fade" id="Admin_model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode" id="exampleModalLabel">Add New Admin</h5>
                    <h5 class="modal-title" v-show="editmode" id="exampleModalLabel">Update Admin</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="editmode ? UpdateAdmin() : CreateAdminMaster()" @keydown="form.onKeydown($event)">
                <div class="modal-body">
                        <div class="form-group">
                            <label>Name</label>
                            <input v-model="form.name" type="text" name="name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input v-model="form.email" type="text" name="email" v-if="!editmode"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                            <input v-model="form.email" type="text" name="email" v-if="editmode" disabled
                                class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                            <has-error :form="form" field="email"></has-error>
                        </div>
                </div>
                <div class="modal-footer">
                    
                    <button type="submit" v-show="!editmode" class="btn btn-primary">Save Admin</button>
                    <button type="submit" v-show="editmode" class="btn btn-success">Update</button>
                </div>
                </form>
                </div>
            </div>
            </div>
            <!--end Model-->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        props : ['userglobaldata'],
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                editmode:false,
                search:'',
                admin_masters:{},
                admin_mastersExcel:[],
                form: new Form({
                    id:'',
                    name:'',
                    email:''
                }),
                columns : [
                    {
                        label: "Name",
                        field: "name",
                    },
                    {
                        label: "Email",
                        field: "email",
                    },
                    {
                        label: "Admin Is Active",
                        field: "Is_Active",
                    },
                ],
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchAdmin();
            })
            Fire.$on('AfterChnageAdmin',()=>{
                this.loadAndSearchAdmin();
            });
        },
        mounted(){
            this.loadAndSearchAdmin();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            UpdateAdmin(){
                this.toast.$emit("LoadingOn");
                this.form.put('user/'+this.form.id)

                .then(()=> {
                    Fire.$emit('AfterChnageAdmin');
                    $('#Admin_model').modal('hide');
                    this.toast.$emit('LoadingOffSuccess', "Admin Updated successfully");
                })
                .catch(()=> {
                    this.toast.$emit('LoadingOffError', "your request could not be processed.");
                })
            },
            editAdmin(admin_master){
                this.editmode = true,
                this.form.reset();
                $('#Admin_model').modal('show');
                this.form.fill(admin_master);
            },
            newAdmin(){
                this.editmode = false,
                this.form.reset();
                $('#Admin_model').modal('show');
            },
            deleteAdmin(id){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if(result.value){
                            this.form.delete('user/'+id).then(()=>{
                            Fire.$emit('AfterChnageAdmin');
                            this.toast.$emit('SwalSuccess',"Deleted!", "Admin Deleted.");

                        }).catch(()=>{
                            this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Admin Is Already In Use");
                        })
                        }
                    })
            },
            CreateAdminMaster(){
                this.toast.$emit("LoadingOn");
                this.form.post('user')
                .then(()=>{
                    $('#Admin_model').modal('hide')
                    // this.loadAndSearchAdmin();
                    Fire.$emit('AfterChnageAdmin');
                    this.toast.$emit('LoadingOffSuccess', "Admin Create successfully");

                })
                .catch(()=>{
                    this.toast.$emit('LoadingOffError', "your Request Failed.");
                })
            },
            loadAndSearchAdmin(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchAdmin?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.admin_masters = data,
                        this.toast.$emit('ProgressBarFinish'),
                        this.loadAndSearchAdminExcel()
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
            loadAndSearchAdminExcel(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchAdminExcel?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.admin_mastersExcel = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
